<template>
  <JoszakiAutocomplete
    :value="value"
    v-bind="$attrs"
    icon="tag"
    :items="labels"
    :loading="$fetchState.pending"
    value-field="description"
    @input="$emit('input', $event)"
    v-on="$listeners"
  >
    <template #empty>
      {{ $t("conductor.common.noResults") }}
    </template>
  </JoszakiAutocomplete>
</template>

<script>
import { ref, useContext, useFetch } from "@nuxtjs/composition-api";
import LABELS_QUERY from "@/stores/admin/queries/labels.graphql";

export default {
  props: {
    value: {
      type: [Array, Object],
      default: () => null,
    },
  },
  setup() {
    const { $query } = useContext();
    const labels = ref([]);

    useFetch(async () => {
      const resp = await $query(LABELS_QUERY, {});
      labels.value = resp.labels;
    });

    return {
      labels,
    };
  },
};
</script>
